interface IconProps {
    iconName: string;
    onClick?: () => void;
    'data-testid'?: string;
}

const Icon = ({ iconName, onClick, 'data-testid': testId }: IconProps) => {
    return (
        <span
            style={{ cursor: 'pointer' }}
            onClick={onClick}
            className={iconName}
            data-testid={testId}
        />
    );
};

export default Icon;
